// @flow
/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';

import ShareMember from '../ShareMember';

import type { ShareMemberType } from '@zapier/team/src/types';

type Props = {
  item: ShareMemberType,
};

const ShareMemberMenuItem = (props: Props) => {
  return (
    <ShareMember
      {...props.item}
      canEdit={false}
      isDisabled={props.item.type === 'member' && props.item.role !== 'member'}
    />
  );
};

export default ShareMemberMenuItem;
